import axios, { AxiosResponse } from "axios";
import { postRequest, getRequest } from "@/Utils/Service/BackendService";
import { ImportProductsToQuoteResponse } from "@/Contracts/ProposalBuilder/ImportProducts";
import { BulkImportPricingTableResponse } from "@/Contracts/ProposalBuilder/Block";

const importQuoteURL = "/v2/blocks/import-quote/";
const bulkImportURL = "/v2/pricing-table-products/bulk/";
const bulkImportTemplateURL = "/v2/pricing-table-products/bulk/template/";

export const importProductsToQuote = async (
	blockId: string,
	file: File,
	lineItemDiscount: string = "0",
	targetMargin: string = "0",
	userPreferences: string = "",
	additionalImages: File[] = [],
	markup?: string
): Promise<ImportProductsToQuoteResponse> => {
	const formData = new FormData();
	formData.append("block_id", blockId);
	formData.append("file", file);
	formData.append("line_item_level_discount_percent", lineItemDiscount);
	if (markup !== undefined && markup !== "") {
		formData.append("target_markup_percent", markup);
	} else {
		formData.append("target_margin_percent", targetMargin);
	}
	if (userPreferences) {
		formData.append("user_preferences", userPreferences);
	}
	for (const img of additionalImages) {
		formData.append("additional_files", img);
	}

	const response: AxiosResponse<ImportProductsToQuoteResponse> = await axios(
		postRequest(importQuoteURL, formData, true, false, true)
	);

	return response.data;
};

export const importUserDefinedProductsToQuote = async (
	blockId: string,
	file: File
): Promise<BulkImportPricingTableResponse> => {
	const formData = new FormData();
	formData.append("block_id", blockId);
	formData.append("file", file);

	const response: AxiosResponse<BulkImportPricingTableResponse> = await axios(
		postRequest(bulkImportURL, formData, true, false, true)
	);

	return response.data;
};

export const downloadBulkImportTemplate = async (
	fileType: "csv" | "xls"
): Promise<Blob> => {
	const url = `${bulkImportTemplateURL}?file_type=${fileType}`;
	const response: AxiosResponse<Blob> = await axios(
		getRequest(url, null, true, false, true)
	);

	return response.data;
};
